<template lang="pug">
.content
  .row
    .col-md-12
      div.box_header
        .col-md-12
            label.title Thêm mới lý thuyết {{lesson_id}}
      div.box_content.lesson
        form(action="#", autocomplete="off")
            .form-group.col-md-12(style="margin:0")
                .alert.alert-danger(v-if="error" style="margin:0") {{error}}
            .form-group.col-md-6(:class='errorArray')
                label.control-label.text-md-right(for="title") Tên lý thuyết *
                input#title.form-control(name="title",required=true,autofocus,placeholder="Tên lý thuyết")
            .form-group.col-md-6(:class='errorArray')
                label.control-label.text-md-right(for="categorys") Danh mục bài học *
                itemCategory(:category='category' @onCategoryChange="onCategoryChange")
            .form-group.col-md-6(:class='errorArray')
                label.control-label.text-md-right(for="subjects") Chọn môn học *
                itemSubject(:subjects='subjects' @onSubjectChange="onSubjectChange")
            .form-group.col-md-6(:class='errorArray')
                label.control-label.text-md-right(for="grades") Chọn khối lớp *
                itemGrade(:grades='grades' @onGradeChange="onGradeChange")
            .form-group(:class='errorArray')
                .col-md-12
                    label.control-label.text-md-right(for="content") Nội dung lý thuyết
                    froala(:tag="'textarea'" :config="config" v-model="content")
            .form-group(:class='errorArray')
                .col-md-12
                    .box-images
                        label.control-label.text-md-right(for="content") 
                            strong Ảnh banner : 
                                span (Kích thước đề nghị: 680x260 px)
                        #list_banner
                        .box-item(v-if="banner" v-for="(banner, index) in lstBanners")
                          span.material-icons(@click='deleteBanner(index)') highlight_off
                          img.img-responsive(:src="banner.src")
                          //- .box-item    
                          //-     span.material-icons highlight_off
                          //-     img(src="../../assets/images/faces/avt-default.png")
                        .box-item.last 
                            input(id="banner" name="banner" type="file" accept="image/*" multiple @change="onFileChange")
                            span 
                                i.material-icons.list-action add
                                strong Tải ảnh lên
                    .clearfix
                .col-md-12
                  p.attach
                      strong File đính kèm
                  .box-attach
                    .box-selected-file
                      input(type='file', name='files[]' multiple)
                      span Chọn file
                      label.files Chọn 2 files
                    .box-item-attach
                        label 
                            i.fa.fa-paperclip
                            span Tenfile.docx
                            span.material-icons.remove delete
                    .box-item-attach
                        label 
                            i.fa.fa-paperclip
                            span Tenfile.docx
                            span.material-icons.remove delete
                    .box-item-attach
                        label 
                            i.fa.fa-paperclip
                            span Tenfile.docx
                            span.material-icons.remove delete
                  .clearfix
                .col-md-12
                  p.attach
                      strong Chia sẻ lý thuyết *
                  .box-attach.theory
                    .box-selected-file
                      p
                        input(type="radio", id="theory1", name="theory", checked)
                        label(for='theory1') Nội dung chưa sẵn sàng hiển thị
                      p
                        input(type="radio", id="theory2",  name="theory")
                        label(for='theory2') Public toàn hệ thống và các lớp học của tôi
                      p
                        input(type="radio", id="theory3", name="theory")
                        label(for='theory3') Chỉ hiển thị trong PC 
                          strong Tên PC có môn học trùng
                          |  của tôi
                        select.select-pc(id="pc" name="pc")
                          option(value="0") Chọn lớp học muốn chia sẻ trong PC
                    .box-item-attach
                        label 
                            i.fa.fa-users
                            span Lớp 6a7 - Hoá học chiều thứ 5
                            span.material-icons.remove delete
                    .box-item-attach
                        label 
                            i.fa.fa-users
                            span Lớp 9a9 Hoá học nâng cao
                            span.material-icons.remove delete
                    .box-item-attach
                        label 
                            i.fa.fa-users
                            span Lớp 9a9 Hoá học nâng cao
                            span.material-icons.remove delete
                  .clearfix
                .form-group(:class='errorArray')
                  .col-md-12
                    .box-footer
                      button(type="submit", class="btn btn-active" @click="submitLesson") Thêm mới
                      button(type="reset", class="btn btn-rest" @click="lessonList") Huỷ yêu cầu

</template>
<script>
import gql from 'graphql-tag'
import itemGrade from '../UserProfile/itemGrade'
import itemSubject from '../UserProfile/itemSubject'
import itemCategory from '../UserProfile/itemCategory'
import graphql from '../Model/graphql'
import S3FileUpload from '../S3FileUpload/S3FileUpload.js'

export default {
  components: {
    itemGrade,
    itemSubject,
    itemCategory,
    S3FileUpload
  },
  data() {
    return {
      error: null,
      errorArray: [],
      grades: [],
      subjects: [],
      category: [],
      lstBanners: [],
      lesson_id: '',
      config: {
        fullPage: true,
        placeholderText: 'Nhập ...',
        charCounterCount: false,
        // iframe: true,
        // imageUploadParam: 'image_param',
        events: {
          'froalaEditor.initialized': function () {
            console.log('initialized')
            // apiKey: 'jUA1yD5B4D1C1F2D1pZGCTRSAPJWTLPLZHTQQb1JGZxE2F2G2B1B10B2A3E6D1G2=='
          }
        }
      },
      content: 'Nhập ...'
    }
  },
  methods: {
    onGradeChange(id) {
      if (id) this.selectedGrade = parseInt(id)
    },
    onSubjectChange(id) {
      if (id) this.selectedSubject = parseInt(id)
    },
    onCategoryChange(id) {
      if (id) this.selectedCategory = parseInt(id)
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      for (let i = 0; i < files.length; i++) {
        let obj = {'name': files[i].name, 'file': files[i], 'src': URL.createObjectURL(files[i])}
        this.lstBanners.push(obj)
      }
    },
    deleteBanner: function (index) {
      this.lstBanners.splice(index, 1)
    },
    lessonList() {
      this.$router.push('lessons')
    },
    submitLesson () {
      if (this.lstBanners.length > 0) {
        let directory = 'images/lessons'
        let config = S3FileUpload.computed.config(directory)
        let S3Client = new S3FileUpload.computed.S3Client(config)
        for (let index = 0; index < this.lstBanners.length; index++) {
          let banner = this.lstBanners[index]
          let file = banner.file
          let fileName = banner.name.split('.')[0]
          let ext = banner.name.split('.')[1]
          let random = Math.random().toString().slice(2)
          let fieldName = `${random}_${fileName}`
          S3Client.uploadFile(file, fieldName).finally(() => {
            let path = `${config.s3Url}/${directory}/${fieldName}.${ext}`
            console.log(path)
          })
        }
      };
    }
  },
  apollo: {
    grades: {
      query: gql(graphql.GET_GRADES),
      update: data => {
        return data.grades
      }
    },
    subjects: {
      query: gql(graphql.GET_SUBJECTS),
      update: data => {
        for (var i = 0; i < data.subjects.length; i++) {
          data.subjects[i].selected = false
        }
        return data.subjects
      }
    },
    category: {
      query: gql(graphql.GET_CATEGORY),
      update: data => {
        for (var i = 0; i < data.category.length; i++) {
          data.category[i].selected = false
        }
        return data.category
      }
    }
  }
}

</script>

<style lang="scss">
    .box_header
        label.title{font-size:20px; font-weight: bold;color:#333;}
    .lesson .form-group .form-control{background-color:#fff;}
        .lesson label.control-label{font-size:13px !important;font-weight:bold; padding-bottom:10px;color:#333;}
        .lesson .box-images{margin: 10px 0 5px 0;} 
            .lesson .box-images strong span{color:#969FAD !important;font-weight: normal !important; }
            .lesson .box-item{float:left;width: 122px;height: 122px; margin-right:20px;margin-bottom:10px; position: relative;}
            .lesson .box-item img{max-width: 100%; height: auto;    max-height: 100%;}
            .lesson .box-item span{position: absolute; right: 5px; top:5px;cursor: pointer;}
            .lesson .box-item.last{margin-right: 0 !important; background: #EAEAEA 0% 0% no-repeat padding-box;box-shadow: 0px 1px 2px #00000029;border: 1px solid #EAEAEA;border-radius: 3px;text-align:center;display:table-cell;vertical-align:middle;line-height:122px; cursor: pointer;}
            .lesson .box-item.last span{text-align:center; display: inline-block;vertical-align: middle;line-height: normal; position:relative; top: auto; right: auto;}
            .lesson .box-item.last strong{display:block; text-align:center;}
        .lesson .attach {margin-top:20px;}
        .lesson .box-attach{background: #fff; padding: 20px 10px;}
          .lesson .box-item-attach{border-top: 1px solid #EAEAEA !important; padding: 5px 10px !important; }
          .lesson .box-item-attach:last-child{border-bottom: 1px solid #EAEAEA !important;}
          .lesson .box-item-attach label{width: 100%; display:block; color:#000;}
          .lesson .box-item-attach .fa-paperclip{transform: rotate(90deg); }
          .lesson .box-item-attach span{padding-left: 10px;}
          .lesson .box-item-attach .remove{float:right; display:block; z-index: 100;}
          .lesson .box-selected-file {padding: 0 10px; margin-bottom:20px; position: relative; width: fit-content;}
          .lesson .box-selected-file span{padding: 5px 15px; background: #FFFFFF 0% 0% no-repeat padding-box;border: 0.5px solid #B4B4B4; border-radius: 3px; cursor: pointer;margin-right: 15px;}
          .lesson .box-selected-file label.files{color: #969FAD;}
          .lesson .box-attach.theory .box-selected-file{width: 100%;}
          .lesson .box-attach.theory i{color: #ccc;}
          .lesson .box-attach.theory [type="radio"]:checked,.box-attach.theory [type="radio"]:not(:checked) { position: absolute; left: -9999px;}
          .lesson  .box-attach.theory [type="radio"]:checked + label,
          .lesson  .box-attach.theory [type="radio"]:not(:checked) + label{position: relative;padding-left: 28px;cursor: pointer;line-height: 20px;display: inline-block;color: #666;}
          .lesson  .box-attach.theory [type="radio"]:checked + label:before,
          .lesson  .box-attach.theory [type="radio"]:not(:checked) + label:before {content: ''; position: absolute;left: 0;top: 0;width: 18px;height: 18px;border: 1px solid #23180A;border-radius: 100%;background: #fff;}
          .lesson  .box-attach.theory [type="radio"]:checked + label:after,
          .lesson  .box-attach.theory [type="radio"]:not(:checked) + label:after {content: '';width: 12px; height: 12px; background: #9F6A28; position: absolute;top: 3px; left: 3px;border-radius: 100%; -webkit-transition: all 0.2s ease;transition: all 0.2s ease;}
          .lesson .box-attach.theory [type="radio"]:not(:checked) + label:after {opacity: 0; -webkit-transform: scale(0);transform: scale(0);}
          .lesson .box-attach.theory [type="radio"]:checked + label:after {opacity: 1; -webkit-transform: scale(1);transform: scale(1);}
          .lesson .box-attach .select-pc{ display: block;background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4;border-radius: 5px;padding: 5px 10px;margin-left:25px;}
    .lesson .box-footer{margin-top:15px;}
      .lesson .btn{text-align: left; font-size: 15px;letter-spacing: 0px;color: #333333; padding: 12px 30px; text-transform: inherit;}
      .lesson .btn-active{background: #FFD311 0% 0% no-repeat padding-box; border-radius: 5px;border: 0 none;}
      .lesson .btn-rest{border: 0 none; margin-left: 10px; background: transparent; box-shadow: none;}
      .lesson .btn-active:hover,.btn-active:active, .btn-active:focus{background: #FFD311 0% 0% no-repeat padding-box; color:#333;box-shadow: none;}
      .lesson .btn-rest:hover, .btn-rest:active, .btn-rest:focus{background: transparent;color: #333;box-shadow: none;}
</style>



// WEBPACK FOOTER //
// view.vue?34bf9b68